(function () {
    'use strict';

    a3_cabin_reports.factory('SaFeedbackInfoFactory', SaFeedbackInfoFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SaFeedbacksFactory
    * @description 
    * Add, Update and Get SaFeedbacks Info
    * @ngInject
    */
    function SaFeedbackInfoFactory(GenericService, defaultCalendarDate) {

        var objType = 'SaFeedbackInfo';
        var objCallback = SaFeedbackInfo;

        /**
         * Initialize the SaFeedbackInfo
         * @memberof SaFeedbacksFactory
         */
        function SaFeedbackInfo() {
            this.questions = [];
            this.assessments = [];
            this.saMembers = [];
            // this.storedFeedbacks = [];
        }



        var service = {
            setSaFeedbacks: setSaFeedbacks,
            getFeedbacksInfo:getFeedbacksInfo,
            getQuestions: getQuestions,
            getSaMembersForFeedback: getSaMembersForFeedback,
            hasSyncedFeedbacks: hasSyncedFeedbacks
        };

        function setSaFeedbacks(feedbacksObj) {
            if (feedbacksObj != null && feedbacksObj.Questions != null && feedbacksObj.Assessments != null) {
                 // Create an empty array to hold all CrewAssessmentMembers
                var crewAssessmentMembers = [];

                // Loop through each assessment and take its CrewAssessmentMembers
                feedbacksObj.Assessments.forEach(function(assessment) {
                    if (assessment.CrewAssessmentMembers && Array.isArray(assessment.CrewAssessmentMembers)) {
                        crewAssessmentMembers = crewAssessmentMembers.concat(assessment.CrewAssessmentMembers);
                    }
                });

                var uniqueMembers = {};
                crewAssessmentMembers.forEach(function(member) {
                    if (member && member.CrewId) {
                        uniqueMembers[member.CrewId] = member;
                    }
                });

                var uniqueMembersArray = Object.keys(uniqueMembers).map(function(key) {
                    return uniqueMembers[key];
                });

                var saFeedbackInfo = { 
                    questions: feedbacksObj.Questions, 
                    assessments: feedbacksObj.Assessments,
                    saMembers: uniqueMembersArray
                }; // saMembers: feedbacksObj.SaMembers , storedFeedbacks : feedbacksObj.StoredFeedbacks};
                GenericService.saveOne(saFeedbackInfo, objType, objCallback);
            }
        }

        /**
         * Get Feedbacks Info from local storage
         */
        function getFeedbacksInfo() {
            return GenericService.getOne(objType, objCallback);
        }

        /**
         * Get SA members for the feedbacks
         */
        function getSaMembersForFeedback(saMembersIdsInRoute) {
            var feedbacksInfo = getFeedbacksInfo();
            // Check if feedbacksInfo or saMembersIdsInRoute is not defined/null
            if (!saMembersIdsInRoute || !feedbacksInfo || !feedbacksInfo.saMembers || !Array.isArray(feedbacksInfo.saMembers)) {
                console.error("Invalid feedbacksInfo or saMembersIdsInRoute");
                return [];
            }

            // Get the current date + 1 day
            var nowPlusOne = new Date();
            nowPlusOne.setDate(nowPlusOne.getDate() + 1);

            if(defaultCalendarDate){
                nowPlusOne = new Date(defaultCalendarDate);
            }

            const commonSaMembers = feedbacksInfo.saMembers.filter(member => {
                const memberEndDate = new Date(member.EndPeriod);
        
                // Check if the member's ID matches and the endDate is valid
                return (
                    saMembersIdsInRoute.includes(member.CrewAimsId) &&
                    memberEndDate >= nowPlusOne // End date is greater than or equal to now + 1
                );
            });

            return commonSaMembers;
        }

        function hasSyncedFeedbacks(dutyNo, dutyDay){
            var isSynced = false;
            var feedbacksInfo = getFeedbacksInfo();
            if(feedbacksInfo && feedbacksInfo.assessments && feedbacksInfo.assessments.length > 0){
                var storedFeedback = feedbacksInfo.assessments.find(f => f.DutyNo == dutyNo && f.DutyDay == dutyDay);
                //add isexist or id not null
                if(storedFeedback && storedFeedback.Id != null){
                    isSynced = true;
                }
            }
            return isSynced;
        }


       /**
         * The question object
         */
        function question() {
			this.Id = null;
			this.Description = null;
			this.Label = null;
			this.OrderNo = null;
			this.ItemValue = 3;
			this.GetId = GetId;
		}

        //Object services
        /**
         * Overide default get Id
         * @memberof CrewAssessmentTemplateFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}

        /**
         * Get questions for the feedback forms
         */
        function getQuestions(){
            var feedbacksInfo = getFeedbacksInfo();

            // Assuming feedbacksInfo.questions is an array of question data
            return feedbacksInfo.questions.map(qData => {
                var q = new question();
                q.Id = qData.Id;
                q.Description = qData.Description;
                q.Label = qData.Label;
                q.OrderNo = qData.OrderNo;
                q.ItemValue = qData.ItemValue || 3; // Default value if not provided
        
                return q;
            });
        }
        return service;
    }

})();